export class UnlikeModel {
    sourceId: string | undefined;
    sourceType: string | undefined;
    userId: string | undefined;
}